import native from 'src/config/native.js'
import sentryConfig from 'src/store/sentry.js'
import GlobalPrototypes from 'src/config/services/globalPrototypes.ts'

/**
 * Get current route information for tracking
 * @returns {string} Current route name, path, or empty string
 */
export const getCurrentRoute = () => {
  const route = GlobalPrototypes.router.currentRoute.value
  return route?.meta?.routeNameForTracking?.(route) || route?.name || route?.path || ''
}

/**
 * Get user segmentation data for tracking
 * @returns {Object} Segmentation data including user info and device
 */
export const getSegmentation = () => {
  const user = GlobalPrototypes.store.getters['users/me']
  const baseSegmentation = { device: native.getDevice(), source: getCurrentRoute(), environment: window?.location?.hostname }
  if (!user) {
    return baseSegmentation
  }
  try {
    const { type, school_id, school } = user
    return {
      ...baseSegmentation,
      type,
      schoolId: school_id,
      slink: school?.slink
    }
  } catch (e) {
    console.log(e)
    sentryReporting(e)
  }
}
/**
 * Get school segmentation data for tracking
 * @returns {Object} Segmentation data including school info
 */

export const getSchoolSegmentation = () => {
  const user = GlobalPrototypes.store.getters['users/me']
  if (!user.type) return {}
  return { type: user.type }
}

/**
 * Report errors to Sentry with additional context
 * @param {Error} e - The error to report
 */
export const sentryReporting = (e) => {
  sentryConfig.addBreadcrumb({
    category: 'exception',
    message: `${e?.name} - ${e?.message}`,
    level: 'error'
  })
  sentryConfig.addBreadcrumb({
    category: '(me) state.me_id',
    message: GlobalPrototypes.store.state?.me_id,
    level: 'warning'
  })
  sentryConfig.addBreadcrumb({
    category: 'users in store',
    message: JSON.stringify(GlobalPrototypes.store.getters['users/stored_user_ids'] || []),
    level: 'warning'
  })
  sentryConfig.throwError('addEvent() failed')
}
